<ll-titulo>Escala Global</ll-titulo>
<ll-toolnavbar>
    <escala-globales-toolnavbar
        [displayButtons]="'all edit'"
        [resourceId]="escalaGlobalId"
    ></escala-globales-toolnavbar>
</ll-toolnavbar>

<escala-globales-view [escalaGlobalId]="escalaGlobalId"></escala-globales-view>
